<template>
  <div>
    <!-- Content Row -->
    <b-row align="left">
      <b-col md="8" class="mt-2">
        <h5 class="font-weight-bold text-primary">Error Log</h5>
      </b-col>
    </b-row>
    <br />
    <div class="text-left">
      <b-row class="mt-4 align-items-end">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="6" class="my-1">
          <b-row>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Created Date (from)"
                class="font-weight-bold m-0"
                label-for="input-1"
              >
                <b-row class="m-0 pr-4">
                  <b-col class="p-0 d-flex form-control img-calender-select border-right-0" md="2">
                    <img src="@/assets/ic-calendar-copy-30.svg" width="100%" alt class />
                  </b-col>
                  <b-col class="px-0">
                    <datepicker
                      input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                      placeholder="Select Date"
                      v-model="created_date_from"
                      :format="customFormatter"
                      :disabledDates="disableCreatedTo"
                    ></datepicker>
                  </b-col>
                  <b-col align="left" md="1" class="px-0">
                    <b-col
                      align="left"
                      class="pt-1 px-4 form-control del-calender-select border-left-0"
                      md="2"
                    >
                      <b-row align="left" class="pt-1">
                        <b-col>
                          <b-link @click="resetCreatedDateFrom" style="text-decoration: none">
                            <i class="text-danger fas fa-times"></i>
                          </b-link>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Created Date (to)"
                class="font-weight-bold m-0"
                label-for="input-1"
              >
                <b-row class="m-0 pr-4">
                  <b-col class="p-0 d-flex form-control img-calender-select border-right-0" md="2">
                    <img src="@/assets/ic-calendar-copy-30.svg" width="100%" alt class />
                  </b-col>
                  <b-col class="px-0 calender-custom-right">
                    <datepicker
                      input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0 "
                      placeholder="Select Date"
                      v-model="created_date_to"
                      :format="customFormatter"
                      :disabledDates="disableCreatedFrom"
                    ></datepicker>
                  </b-col>
                  <b-col align="left" md="1" class="px-0">
                    <b-col
                      align="left"
                      class="pt-1 px-4 form-control del-calender-select border-left-0"
                      md="2"
                    >
                      <b-row align="left" class="pt-1">
                        <b-col>
                          <b-link @click="resetCreatedDateTo" style="text-decoration: none">
                            <i class="text-danger fas fa-times"></i>
                          </b-link>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>
          We're sorry, we're not able to retrieve this information at the moment, please try back
          later
        </p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        responsive
        show-empty
        ref="pxContent"
        hover
        :items="getLogs"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
        filter-debounce="500"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(type)="row">
          <div class="text-capitalize">
            <span :class="row.value == 'error' ? 'text-danger' : 'text-success'">
              {{ row.value }}
            </span>
          </div>
        </template>

        <template v-slot:cell(action)="{ value, item }">
          <div
            class="text-primary"
            style="cursor: pointer;"
            @click="
              () => {
                showDetail = true;
                selectedItem = item;
              }
            "
          >
            <i class="fas fa-eye"></i>
          </div>
        </template>
      </b-table>

      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{ totalRows }}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
    <b-modal v-model="showDetail" id="modal-logs" hide-header hide-footer size="xl">
      <div class="d-flex p-4" style="gap:1rem;">
        <div style="flex:1;">
          <span>
            RESPONSE
          </span>
          <div class="overflow-auto" style="max-height:70vh;overflow: auto;max-width: 500px;">
            <TemplateCode>
              {{parseStringToObject(selectedItem.response)}}
            </TemplateCode>
          </div>
        </div>
        <div style="flex:1;">
          <span>
            REQUEST
          </span>
          <div class="overflow-auto" style="max-height:70vh;overflow: auto;max-width: 500px;">
            <TemplateCode>
              {{parseStringToObject(selectedItem.payload)}}
            </TemplateCode>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import TemplateCode from "./component/TemplateCode.vue";
export default {
  components: {
    Datepicker,
    TemplateCode
  },
  data() {
    return {
      created_date_from: new Date(Date.now() - 8640000),
      created_date_to: new Date(Date.now()),
      // Show Detail Modal
      showDetail: false,
      loading: false,
      errored: false,
      selectedItem: {},
      fields: [
        {
          key: "member_code",
          label: "Member Code",
          sortable: false,
          class: "text-center"
        },
        {
          key: "transaction_id",
          label: "Transaction Id",
          sortable: false,
          class: "text-center"
        },
        {
          key: "type",
          label: "Type",
          sortable: false,
          class: "text-center"
        },
        {
          key: "from",
          label: "From",
          sortable: false,
          class: "text-center"
        },
        {
          key: "message",
          label: "Message",
          sortable: false,
          class: "text-center"
        },
        {
          key: "created_at",
          label: "Created At",
          sortable: false,
          class: "text-center"
        },
        { key: "action", label: "Action", class: "text-center" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: "",
      error_logs: []
    };
  },
  watch: {
    createdDate: {
      handler: function(newValue) {
      },
      deep: true
    },
    created_date_from: {
      handler: function(newValue) {
        if (newValue) {
          var date2 = new Date();
          date2.setDate(date2.getDate() - 7);
          if(newValue> date2){
            this.disableCreatedFrom = newValue;
          }else{
            this.$swal({
              type: "error",
              title: "Filter Failed",
              text: 'Date is limited for the last 7 days',
              showConfirmButton: false,
              timer: 1500
            });
            this.resetCreatedDateFrom()
          }
        }
      },
      deep: true
    },
    created_date_to: {
      handler: function(newValue) {
        if (newValue) {
          this.disableCreatedTo = newValue;
        }
      },
      deep: true
    }
  },
  computed: {
    createdDate() {
      return {
        from: this.created_date_from,
        to: this.created_date_to
      };
    },
    disableCreatedFrom: {
      get: function() {
        let date = this.created_date_from ? this.created_date_from : null;
        let disabledDates = {
          to: new Date(date - 8640000),
          from: new Date(Date.now() + 8640000)
        };
        return disabledDates;
      },
      set: function(newValue) {
        this.created_date_from = newValue || "";
        this.triggerGet()
      }
    },
    disableCreatedTo: {
      get: function() {
        let date = this.created_date_to ? this.created_date_to : Date.now();
        let disabledDates = {
          from: new Date(date + 8640000)
        };
        return disabledDates;
      },
      set: function(newValue) {
        this.created_date_to = newValue || "";
        this.triggerGet()
      }
    }
  },
  methods: {
    resetCreatedDateFrom() {
      this.created_date_from = "";
    },
    resetCreatedDateTo() {
      this.created_date_to = "";
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    getLogs(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      formData.append(
        "start_date",
        this.created_date_from ? moment(this.created_date_from).format("YYYY-MM-DD") : ""
      );
      formData.append(
        "end_date",
        this.created_date_to ? moment(this.created_date_to).format("YYYY-MM-DD") : ""
      );
      this.$store
        .dispatch("ErrorLogModule/getErrorLogs", formData)
        .then(response => {
          vm.totalRows = response.total_record;
          callback(response.results || []);
          this.loading = false;
          this.error_logs = response.results;
        })
        .catch(error => {
          this.loading = false;
          callback([]);
        });
      return null;
    },
    triggerGet(){
      this.$refs.pxContent.refresh();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    parseStringToObject(string){
      try {
        return JSON.parse(string);
      } catch(ex){
        return string;
      }
    }
  }
};
</script>

<style>
.calender-custom-right .vdp-datepicker__calendar { right: 0; } /* fixing calender mentok kanan kepotong */
</style>
